import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { FiltersToolbarFilter } from '@hqo/filters-toolbar';
import { MultiSelect } from '@hqo/multi-select';
import { Badge } from '@hqo/ui-atoms';
import { cn } from '@hqo/react-hooks';

import { useCompanyFilter } from './use-company-filter.hook';

export const CompanyFilter = (): JSX.Element => {
  const { options, selectedOptions, companyLabel, selectedCount, handleChange, isSet, isLoading } = useCompanyFilter();
  const { formatMessage } = useIntl();
  const selectAllLabel = formatMessage({ id: 'labels.filtersToolbar.selectAll', defaultMessage: 'Select all' });

  const moreLabel = useMemo(
    () =>
      selectedCount ? (
        <span className="inline-flex items-center gap-1">
          {companyLabel}
          <Badge className="px-1 py-0 text-[11px] leading-none">{selectedCount}</Badge>
        </span>
      ) : undefined,
    [companyLabel, selectedCount],
  );

  return (
    <FiltersToolbarFilter priority={5} order={2} id="company" isSet={isSet} className="min-w-52 max-w-70">
      <MultiSelect
        className={cn(
          'bg-shared-white min-h-8 h-8 rounded-lg text-sm font-normal [&>div>span]:font-normal [&>div>span]:text-sm hover:bg-shared-white',
        )}
        canClear={false}
        canClose={false}
        placeholder={companyLabel}
        selectAllLabel={selectAllLabel}
        selectedOptions={selectedOptions}
        options={options}
        onChange={handleChange}
        loading={isLoading}
        maxCount={selectedOptions.length > 1 ? 0 : 1}
        hideMoreDeselect
        moreLabel={moreLabel}
      />
    </FiltersToolbarFilter>
  );
};
